import React, { useEffect, useState } from 'react';
import { getAllowedModules } from '../api/terminals';

export function ModulePicker({ selected, onChange }) {
  const [modules, setModules] = useState([]);

  useEffect(() => {
    getAllowedModules().then(setModules);
  }, []);

  function toggle(name) {
    if (selected.includes(name)) {
      onChange(selected.filter((m) => m !== name));
    } else {
      onChange([...selected, name]);
    }
  }

  return (
    <div className="module-picker">
      {modules.map((m) => (
        <label key={m.name} className="module-item" title={m.description}>
          <input type="checkbox" checked={selected.includes(m.name)} onChange={() => toggle(m.name)} />
          <span className="module-label">{m.label}</span>
          <span className="module-desc">{m.description}</span>
        </label>
      ))}
    </div>
  );
}
